import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Link,
  Alert,
  Divider,
  IconButton,
  Stack
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import GroupsIcon from '@mui/icons-material/Groups';
import PeopleIcon from '@mui/icons-material/People';
import EventIcon from '@mui/icons-material/Event';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Automationforce from '../images/AF_Logo.png';
import { sendMessage } from '../group/apigroup';

class Footer extends Component {
  constructor() {
    super();
    this.state = {
      email: '',
      emailSent: false,
      emailError: false
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = (val) => {
    this.setState({ email: val });
  }

  async handleSubmit(event) {
    event.preventDefault();

    // Email validation regex
    // eslint-disable-next-line no-useless-escape
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (re.test(this.state.email)) {
      const mailMessage = {
        "subject": "SDSIC Newsletter request",
        "from": "donotreply@sdsconsortium.com",
        "to": [{ "name": "Trevor", "address": "trevor@sdsconsortium.com" }],
        "html": `<html><body><p>add email: ${this.state.email} to the newsletter list.</p></body></html>`
      }

      const result = await sendMessage(mailMessage);
      if (!result || result.error) {
        this.setState({ emailSent: false, emailError: true });
        return;
      }

      this.setState({
        email: '',
        emailSent: true,
        emailError: false
      });

    } else {
      this.setState({ emailError: true })
    }
  };

  render() {
    const linkStyle = {
      color: '#b3c5d7',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      transition: 'all 0.3s ease',
      fontSize: '0.875rem',
      '&:hover': {
        color: '#FF6600',
        transform: 'translateX(4px)'
      }
    };

    return (
      <Box
        component="footer"
        sx={{
          width: '100%',
          mt: 'auto',
          flexShrink: 0
        }}
      >
        {/* Accent Bar */}
        <Box
          sx={{
            height: '4px',
            background: 'linear-gradient(90deg, #003E7E 0%, #FF6600 100%)'
          }}
        />

        {/* Main Footer Content */}
        <Box
          sx={{
            backgroundColor: '#003E7E',
            pt: 6,
            pb: 3
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={4}>
              {/* Company Info */}
              <Grid item xs={12} md={6} lg={4}>
                {/* SDSIC Branding */}
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 700,
                      color: 'white',
                      mb: 2,
                      letterSpacing: '-0.5px'
                    }}
                  >
                    <Box component="span" sx={{ color: '#FF6600' }}>SDS</Box>
                    <Box component="span">IC</Box>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#b3c5d7',
                      lineHeight: 1.8,
                      mb: 3
                    }}
                  >
                    SDS Industry Consortium - Empowering collaboration and innovation in the substation automation industry.
                  </Typography>
                </Box>

                {/* Automationforce Credit */}
                <Box
                  sx={{
                    p: 2,
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    borderRadius: 2,
                    borderLeft: '3px solid #FF6600',
                    mb: 3
                  }}
                >
                  <Box sx={{ mb: 1.5 }}>
                    <img
                      src={Automationforce}
                      height="40px"
                      alt="Automationforce"
                    />
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#b3c5d7',
                      fontSize: '0.8rem',
                      lineHeight: 1.6
                    }}
                  >
                    Platform built by{' '}
                    <Link
                      href="https://automationforce.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: '#FF6600',
                        fontWeight: 600,
                        textDecoration: 'none',
                        '&:hover': {
                          textDecoration: 'underline'
                        }
                      }}
                    >
                      Automationforce
                    </Link>
                  </Typography>
                </Box>

                {/* Social Media */}
                <Box>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'white',
                      mb: 1.5,
                      fontWeight: 600,
                      fontSize: '0.875rem',
                      letterSpacing: '0.5px',
                      textTransform: 'uppercase'
                    }}
                  >
                    Connect With Us
                  </Typography>
                  <IconButton
                    component="a"
                    href="https://www.linkedin.com/company/sds-industry-consortium"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      color: 'white',
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      border: '1px solid rgba(255, 255, 255, 0.2)',
                      '&:hover': {
                        backgroundColor: '#0077b5',
                        borderColor: '#0077b5',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 4px 8px rgba(0, 119, 181, 0.3)'
                      },
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <LinkedInIcon />
                  </IconButton>
                </Box>
              </Grid>

              {/* Quick Links Column 1 */}
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'white',
                    mb: 3,
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    textTransform: 'uppercase',
                    borderBottom: '2px solid #FF6600',
                    pb: 1,
                    display: 'inline-block'
                  }}
                >
                  Explore
                </Typography>
                <Stack spacing={1.5}>
                  <Link href="/" sx={linkStyle}>
                    <HomeIcon sx={{ fontSize: 18 }} />
                    <Typography variant="body2">Home</Typography>
                  </Link>
                  <Link href="/about" sx={linkStyle}>
                    <InfoIcon sx={{ fontSize: 18 }} />
                    <Typography variant="body2">About Us</Typography>
                  </Link>
                  <Link href="/awards" sx={linkStyle}>
                    <EmojiEventsIcon sx={{ fontSize: 18 }} />
                    <Typography variant="body2">Our Awards</Typography>
                  </Link>
                  <Link href="/podcast" sx={linkStyle}>
                    <PodcastsIcon sx={{ fontSize: 18 }} />
                    <Typography variant="body2">PowerUp Podcast</Typography>
                  </Link>
                </Stack>
              </Grid>

              {/* Quick Links Column 2 */}
              <Grid item xs={12} sm={6} md={3} lg={2}>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'white',
                    mb: 3,
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    textTransform: 'uppercase',
                    borderBottom: '2px solid #FF6600',
                    pb: 1,
                    display: 'inline-block'
                  }}
                >
                  Community
                </Typography>
                <Stack spacing={1.5}>
                  <Link href="/grouplist" sx={linkStyle}>
                    <GroupsIcon sx={{ fontSize: 18 }} />
                    <Typography variant="body2">Committees</Typography>
                  </Link>
                  <Link href="/findpeople" sx={linkStyle}>
                    <PeopleIcon sx={{ fontSize: 18 }} />
                    <Typography variant="body2">Find Members</Typography>
                  </Link>
                  <Link href="/allevents" sx={linkStyle}>
                    <EventIcon sx={{ fontSize: 18 }} />
                    <Typography variant="body2">Events</Typography>
                  </Link>
                </Stack>
              </Grid>

              {/* Newsletter Section */}
              <Grid item xs={12} md={12} lg={4}>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'white',
                    mb: 3,
                    fontSize: '0.875rem',
                    fontWeight: 700,
                    letterSpacing: '1px',
                    textTransform: 'uppercase',
                    borderBottom: '2px solid #FF6600',
                    pb: 1,
                    display: 'inline-block'
                  }}
                >
                  Stay Updated
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#b3c5d7',
                    mb: 2.5,
                    lineHeight: 1.8,
                    fontSize: '0.875rem'
                  }}
                >
                  Subscribe to receive the latest news, events, and industry insights from SDSIC.
                </Typography>
                <Box
                  component="form"
                  onSubmit={this.handleSubmit}
                  sx={{ mb: 2 }}
                >
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    <TextField
                      id="email"
                      type="text"
                      value={this.state.email}
                      placeholder="Your email address"
                      aria-label="Newsletter email"
                      onChange={event => this.handleChange(event.target.value)}
                      size="small"
                      fullWidth
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          backgroundColor: 'rgba(255, 255, 255, 0.08)',
                          color: 'white',
                          borderRadius: 1,
                          '& fieldset': {
                            borderColor: 'rgba(255, 255, 255, 0.15)'
                          },
                          '&:hover fieldset': {
                            borderColor: 'rgba(255, 255, 255, 0.25)'
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#FF6600',
                            borderWidth: '2px'
                          }
                        },
                        '& .MuiInputBase-input::placeholder': {
                          color: '#b3c5d7',
                          opacity: 0.7
                        }
                      }}
                    />
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        minWidth: 'auto',
                        px: 3,
                        backgroundColor: '#FF6600',
                        borderRadius: 1,
                        boxShadow: '0 2px 4px rgba(255, 102, 0, 0.3)',
                        '&:hover': {
                          backgroundColor: '#e55a00',
                          boxShadow: '0 4px 8px rgba(255, 102, 0, 0.4)',
                          transform: 'translateY(-1px)'
                        },
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <SendIcon />
                    </Button>
                  </Box>
                </Box>
                {this.state.emailSent && (
                  <Alert
                    severity="success"
                    sx={{
                      mt: 2,
                      backgroundColor: 'rgba(76, 175, 80, 0.15)',
                      color: '#81c784',
                      border: '1px solid rgba(76, 175, 80, 0.3)',
                      '& .MuiAlert-icon': {
                        color: '#81c784'
                      }
                    }}
                  >
                    Thank you! Your email has been added to our newsletter.
                  </Alert>
                )}
                {this.state.emailError && (
                  <Alert
                    severity="error"
                    sx={{
                      mt: 2,
                      backgroundColor: 'rgba(244, 67, 54, 0.15)',
                      color: '#e57373',
                      border: '1px solid rgba(244, 67, 54, 0.3)',
                      '& .MuiAlert-icon': {
                        color: '#e57373'
                      }
                    }}
                  >
                    Please enter a valid email address.
                  </Alert>
                )}
              </Grid>
            </Grid>

            {/* Bottom Bar */}
            <Divider sx={{ mt: 6, mb: 4, borderColor: 'rgba(255, 255, 255, 0.15)' }} />
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 2
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: '#b3c5d7',
                  fontSize: '0.8rem',
                  textAlign: { xs: 'center', sm: 'left' }
                }}
              >
                &copy; {new Date().getFullYear()} <Box component="span" sx={{ fontWeight: 600, color: 'white' }}>SDSIC</Box>. All rights reserved.
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: '#b3c5d7',
                    fontSize: '0.8rem'
                  }}
                >
                  Powered by
                </Typography>
                <Link
                  href="https://automationforce.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    color: '#FF6600',
                    fontSize: '0.8rem',
                    fontWeight: 600,
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  Automationforce
                </Link>
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
    );
  }
}

export default withRouter(Footer);
